import { IngredientDraftRow, IngredientPercentageItem } from "../types/recipeAddIngredient.types";

export function createCompositeKey(productId: string, salesUnitId: string): string {
  return `${productId}-${salesUnitId}`;
}

export function parseCompositeKey(compositeKey: string): [string, string] | null {
  const separatorIndex = compositeKey.indexOf("-");
  if (separatorIndex <= 0 || separatorIndex === compositeKey.length - 1) {
    return null;
  }
  return [compositeKey.slice(0, separatorIndex), compositeKey.slice(separatorIndex + 1)];
}

export function sumPercentages(items: IngredientPercentageItem[]): number {
  return items.reduce((sum, item) => sum + (Number(item.percentage) || 0), 0);
}

export function calculateExistingIngredientTotal(
  calculatedProductSalesUnit: IngredientPercentageItem[],
  genericIngredient: IngredientPercentageItem[],
  calculatedIngredient: IngredientPercentageItem[]
): number {
  return (
    sumPercentages(calculatedProductSalesUnit) +
    sumPercentages(genericIngredient) +
    sumPercentages(calculatedIngredient)
  );
}

export function calculateSavedDraftTotal(drafts: IngredientDraftRow[]): number {
  return drafts
    .filter(draft => draft.saved)
    .reduce((sum, draft) => sum + (Number(draft.percentage) || 0), 0);
}

export function calculatePendingDraftTotal(drafts: IngredientDraftRow[]): number {
  return drafts
    .filter(draft => !draft.saved)
    .reduce((sum, draft) => sum + (Number(draft.percentage) || 0), 0);
}

export function calculateRemainingCapacity(
  existingTotal: number,
  pendingDraftTotal: number
): number {
  return Math.max(0, 100 - existingTotal - pendingDraftTotal);
}

export function clampPercentage(value: number, maxAllowed: number): number {
  if (Number.isNaN(value) || value < 0) return 0;
  return Math.min(value, maxAllowed);
}

export function getMaxAllowedForRow(drafts: IngredientDraftRow[], rowIndex: number): number {
  const otherTotal = drafts
    .filter((_, index) => index !== rowIndex)
    .reduce((sum, draft) => sum + (Number(draft.percentage) || 0), 0);

  return Math.max(0, 100 - otherTotal);
}

export function formatPercentage(value: number): string {
  return value.toFixed(1);
}
